<!-- Copyright 2020 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0
Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License. -->

import {Layout} from '@react-spectrum/docs';
export default Layout;

import docs from 'docs:@react-aria/ssr';
import {HeaderInfo, FunctionAPI} from '@react-spectrum/docs';
import packageData from '@react-aria/ssr/package.json';

---
category: Server Side Rendering
keywords: [ssr, server side rendering, aria, next.js, gatsby]
---

# useIsSSR

<p>{docs.exports.useIsSSR.description}</p>

<HeaderInfo
  packageData={packageData}
  componentNames={['useIsSSR']} />

## API

<FunctionAPI function={docs.exports.useIsSSR} links={docs.links} />

## Introduction

`useIsSSR` returns `true` during server rendering and hydration, and updates to `false`
immediately after hydration. This can be used to ensure that the server rendered HTML
and initially hydrated DOM match, but trigger an additional render after hydration to
run browser-specific code. For example, it could be used to run media queries or feature
detection for browser-specific APIs that affect rendering but cannot be run server side.

This hook must be used in combination with the [SSRProvider](SSRProvider.html) component
wrapping your application. See the [server side rendering](ssr.html) docs for more information.

## Example

```tsx
import {useIsSSR} from '@react-aria/ssr';

function MyComponent() {
  let isSSR = useIsSSR();
  return <span>{isSSR ? 'Server' : 'Client'}</span>;
}
```
